import { useMutation } from '@apollo/client';
import { graphql } from '../gql';
import { GET_BIND_PAGE } from './bind-page.query';
import { GET_POLICY_PAGE } from './policy-page.query';

export const UPDATE_SUBJECTIVITY = graphql(`
  mutation updateQuoteSubjectivity(
    $details: HasSubjectivityInput!
    $submissionUuid: String!
    $subjectivityUuid: String!
    $quoteUuid: String!
  ) {
    updateQuoteSubjectivity(
      details: $details
      submissionUuid: $submissionUuid
      subjectivityUuid: $subjectivityUuid
      quoteUuid: $quoteUuid
    ) {
      uuid
    }
  }
`);

export function useUpdateQuoteSubjectivityMutation() {
  const [updateQuoteSubjectivity, { loading, error, reset }] = useMutation(
    UPDATE_SUBJECTIVITY,
    {
      refetchQueries: [GET_BIND_PAGE, GET_POLICY_PAGE],
      awaitRefetchQueries: true,
    }
  );

  return {
    updateQuoteSubjectivity,
    loading,
    error,
    reset,
  };
}
